import { defineComponent as l, toRef as c, h as t, withDirectives as p, vShow as u } from "vue";
import a from "./ghl-ui.es705.js";
import d from "./ghl-ui.es858.js";
const w = l({
  name: "CollapseItemContent",
  props: {
    displayDirective: {
      type: String,
      required: !0
    },
    show: Boolean,
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return {
      onceTrue: a(c(e, "show"))
    };
  },
  render() {
    return t(d, null, {
      default: () => {
        const {
          show: e,
          displayDirective: o,
          onceTrue: s,
          clsPrefix: n
        } = this, i = o === "show" && s, r = t("div", {
          class: `${n}-collapse-item__content-wrapper`
        }, t("div", {
          class: `${n}-collapse-item__content-inner`
        }, this.$slots));
        return i ? p(r, [[u, e]]) : e ? r : null;
      }
    });
  }
});
export {
  w as default
};
